// apiSlice.js
import { authHeader } from '../utils/authHeaders';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL, BASE_WORDURL } from '../components/constants';

// Thunk for user files
// apiSlice.js
export const fetchUserFiles = createAsyncThunk(
    'api/fetchUserFiles',
    async ({userId, historyId, taskId, organizationId}) => {
      if (!userId || !historyId) return { files: [], total_files: 0, historyId: null };

      // Build URL with query params for task_id and organization_id
      let url = `${BASE_URL}/files/${userId}/${historyId}`;
      const params = new URLSearchParams();
      if (taskId) params.append('task_id', taskId);
      if (organizationId) params.append('organization_id', organizationId);
      if (params.toString()) url += `?${params.toString()}`;

      const response = await fetch(url, {
        headers: { ...authHeader() },
      });
      const data = await response.json();
      console.log(data, response)
      // Include historyId in response to track which project these files belong to
      return { ...data, historyId };
    }
  );
// Lists this user's Word-generation output for an agent — Sidebar's
// "Generated files" tab. Scoped server-side to (history_id, user_id) — same
// scope as fetchUserFiles' Uploaded list — see db.py's
// get_generated_documents_for_history.
export const fetchGeneratedDocuments = createAsyncThunk(
  'api/fetchGeneratedDocuments',
  async ({ userId, historyId }) => {
    if (!userId || !historyId) return { documents: [] };
    const params = new URLSearchParams({ history_id: historyId });
    const response = await fetch(`${BASE_WORDURL}/list?${params.toString()}`, {
      headers: { ...authHeader() },
    });
    return response.json();
  }
);

export const deleteGeneratedDocument = createAsyncThunk(
  'api/deleteGeneratedDocument',
  async ({ documentId }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_WORDURL}/${documentId}`, {
        method: 'DELETE',
        headers: { ...authHeader() },
      });
      if (!response.ok) throw new Error('Failed to delete document');
      return { documentId };
    } catch (err) {
      return rejectWithValue({ message: err.message || 'Failed to delete document', documentId });
    }
  }
);

// You can add other API calls here
// export const anotherApiCall = createAsyncThunk(...)

const apiSlice = createSlice({
  name: 'api',
  initialState: {
    userFiles: [], // changed from files to userFiles
    userFilesStatus: 'idle', // changed from status to userFilesStatus
    userFilesError: null, // changed from error to userFilesError
    userFilesHistoryId: null, // Track which historyId the files belong to
    // You can add more API-related states here
    generatedDocuments: [],
    generatedDocumentsStatus: 'idle',
    generatedDocumentsError: null,
    generatedDocumentsRequestId: null,
  },
  reducers: {
    clearUserFiles: (state) => {
      state.userFiles = [];
      state.userFilesStatus = 'idle';
      state.userFilesError = null;
      state.userFilesHistoryId = null;
    },
    clearGeneratedDocuments: (state) => {
      state.generatedDocuments = [];
      state.generatedDocumentsStatus = 'idle';
      state.generatedDocumentsError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserFiles.pending, (state) => {
        state.userFilesStatus = 'loading';
      })
      .addCase(fetchUserFiles.fulfilled, (state, action) => {
        state.userFilesStatus = 'succeeded';
        state.userFiles = action.payload;
        state.userFilesHistoryId = action.payload.historyId || null;
      })
      .addCase(fetchUserFiles.rejected, (state, action) => {
        state.userFilesStatus = 'failed';
        state.userFilesError = action.error.message;
      })
      .addCase(fetchGeneratedDocuments.pending, (state, action) => {
        state.generatedDocumentsStatus = 'loading';
        state.generatedDocumentsRequestId = action.meta.requestId;
      })
      .addCase(fetchGeneratedDocuments.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.generatedDocumentsRequestId) return; // stale response, a newer request is already in flight
        state.generatedDocumentsStatus = 'succeeded';
        state.generatedDocuments = action.payload.documents || [];
      })
      .addCase(fetchGeneratedDocuments.rejected, (state, action) => {
        if (action.meta.requestId !== state.generatedDocumentsRequestId) return;
        state.generatedDocumentsStatus = 'failed';
        state.generatedDocumentsError = action.error.message;
      })
      .addCase(deleteGeneratedDocument.fulfilled, (state, action) => {
        state.generatedDocuments = state.generatedDocuments.filter(
          (doc) => doc.id !== action.payload.documentId
        );
      });

    // You can add more API cases here
  }
});

export default apiSlice.reducer;
export const { clearUserFiles, clearGeneratedDocuments } = apiSlice.actions;